module.exports = __webpack_public_path__ + "3217f3ab32e0799e0a40d03a23f27d9e.jpg";